import React from 'react';
import ImageGalleryImage from './ImageGalleryImage';
import {take, map, compact} from 'lodash';
import {Thumbnail, Thumbnails} from './ImageGallery.styles.js'
import {variables} from 'theme/variables';
const {  
  custom_blue
} = variables;


class ThumbnailSlider extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }

  render() {
    let images = compact(this.props.images);
    images = this.props.limit ? take(images, this.props.limit) : images;
    const extra = this.props.limit && this.props.images && this.props.images.length  > this.props.limit;
    if (extra) {
      images.push({extra: this.props.images.length - this.props.limit})
    }

    const thumbnails = map(images, (img, i) => {
      return (
        <Thumbnail large={this.props.large} key={i} style={this.props.activeImageIndex === i ? {border: `1px solid ${custom_blue}`} : {border: '1px solid transparent'}} onClick={img.extra ? this.props.onExpand : this.props.onImageClicked.bind(this, i, img)}>
          <ImageGalleryImage thumbnail={true} cursor="pointer" image={img} />
        </Thumbnail>
      );
    });

    return (
      <Thumbnails>
        {thumbnails}
      </Thumbnails>
    );
  }
}

export default ThumbnailSlider;

